<!-- 講座体験談カード -->
<script setup lang="ts">
  import { PlanReviewInfo } from "~/entities/PlanReviewInfo";
  interface Props {
    review: PlanReviewInfo;
    isOwner?: boolean;
  }
  const props = defineProps<Props>();

  interface Emits {
    (event: "onPrivate", review: PlanReviewInfo, isPrivate: boolean): void;
    (event: "onDelete", review: PlanReviewInfo): void;
  }
  const emit = defineEmits<Emits>();

  const deleteReview = () => {
    emit("onDelete", props.review);
  };

  const isPrivate = computed<boolean>({
    get: () => props.review.isPrivate,
    set: value => {
      if (props.review.isPrivate !== value) {
        emit("onPrivate", props.review, value);
      }
    },
  });

  const isSp = isSpDisplayRef();
</script>

<template>
  <v-sheet color="transparent" class="w-100 d-inline-flex justify-start align-center">
    <div class="mr-4">
      <AtomsUserIcon :src="review.user.userImage" :width="35" :height="35" />
    </div>
    <div class="">
      <p class="">{{ review.user.userName }}</p>
    </div>
  </v-sheet>
  <v-sheet color="transparent" class="mt-2 mb-1">
    <p class="review-title">{{ review.title }}</p>
  </v-sheet>
  <v-sheet
    color="transparent"
    class="w-100 d-flex justify-start mb-2"
    :class="{ 'flex-column': isSp, 'align-center': !isSp, 'align-start': isSp }"
  >
    <p class="review-date">{{ dateToYYYYMMDDWithLocale(review.reviewDate) }}に投稿</p>
    <div v-if="isOwner" :class="{ 'ml-4': !isSp }">
      <AtomsChipSwitch v-model:is-first="isPrivate" label1="非公開" label2="公開" size="large"></AtomsChipSwitch>
    </div>
    <p v-if="isOwner" class="delete-review" :class="{ 'ml-4': !isSp }" @click="deleteReview">この体験談を削除する</p>
  </v-sheet>
  <v-sheet color="transparent" class="w-100">
    <p class="review-text text-left">{{ review.content }}</p>
  </v-sheet>
</template>

<style lang="scss" scoped>
  .review-date {
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    line-height: 1.8em;
    letter-spacing: 0.06em;
    color: rgb(var(--v-theme-monochrome-02));
  }
  .review-title {
    font-size: 16px;
    font-weight: 700;
    text-align: left;
    line-height: 1.8em;
    letter-spacing: 0.06em;
  }
  .review-text {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.8em;
    letter-spacing: 0.06em;
    white-space: break-spaces;
  }
  .delete-review {
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    line-height: 1.8em;
    letter-spacing: 0.06em;
    color: rgb(var(--v-theme-main-04));
    cursor: pointer;
  }
</style>
